import { render, staticRenderFns } from "./LeaveDetailsTableControl.vue?vue&type=template&id=24467721&scoped=true&"
import script from "./LeaveDetailsTableControl.vue?vue&type=script&lang=js&"
export * from "./LeaveDetailsTableControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24467721",
  null
  
)

export default component.exports